export default __webpack_public_path__ + "static/media/blog-five.5e617bdc.png";